// навішуємо івент на кнопку map-btn у секції address для скрола до карти mapbox
const showMapBtn = document.querySelector('.js-map-btn')
if (showMapBtn) {
    showMapBtn.addEventListener('click', () => {
        document.querySelector('#mapbox')?.scrollIntoView({ behavior: "smooth", block: "center" })
    })
}
